import { render } from "./ResearchOfficersComponent.vue?vue&type=template&id=b2bf49d0&scoped=true"
import script from "./ResearchOfficersComponent.vue?vue&type=script&lang=js"
export * from "./ResearchOfficersComponent.vue?vue&type=script&lang=js"

import "./ResearchOfficersComponent.vue?vue&type=style&index=0&id=b2bf49d0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2bf49d0"]])

export default __exports__